import React from 'react'
import { getGeoCountry, getGeoRegion } from 'utils/primeUtil'
import { Heading, HeadingStyle, StoryBlockerContainer, StoryBlockerInner, StoryBlockerInnerStyle, StoryBlockerStyle } from '../StoryBlockerNew/StoryBlockerNew.style'

interface IEuBlockerScreen {
    isLoggedIn: boolean
    loginComponent: React.ReactElement;
}

const EuBlockerScreen = (props: IEuBlockerScreen) => {

    const { isLoggedIn, loginComponent } = props;

    const downLoadNowBtn = () => (
        <div className="btnGrp">
            <a href='https://apps.apple.com/us/app/the-times-of-india/id427589329' className={'buyplan'}>
                DOWNLOAD APP NOW
            </a>
        </div>
    );

    return (
        <StoryBlockerContainer styles={StoryBlockerStyle}>
            <StoryBlockerInner styles={StoryBlockerInnerStyle} className='gdprBlocker'>
                <Heading styles={HeadingStyle} className='gdprHeading'>
                    {getGeoRegion() === 'CA' && getGeoCountry() === 'US' ?
                        'You can only purchase TOI+ on the IOS app in your region.Download the app &amp; get TOI+ for free by signing up with TimesClub on the app.'
                        : 'You can only purchase TOI+ on the IOS app in your region.'
                    }
                </Heading>
                {downLoadNowBtn()}
                {!isLoggedIn ? loginComponent : null}
            </StoryBlockerInner>
        </StoryBlockerContainer>
    )
}

export default EuBlockerScreen;